import { render } from "./inicio.vue?vue&type=template&id=43d0ce12&scoped=true"
import script from "./inicio.vue?vue&type=script&lang=js"
export * from "./inicio.vue?vue&type=script&lang=js"

import "./inicio.vue?vue&type=style&index=0&id=43d0ce12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43d0ce12"]])

export default __exports__